import React, { useState } from "react";
import { IonContent, IonButton, IonModal, IonIcon } from "@ionic/react";
import { useBiometricAuth } from "../../../hooks/useBiometrics";
import { close } from "ionicons/icons";
import analytics from "../../../services/firebaseAnalytics";

interface InfoArcConnectProps {
  closeModal: () => void;
  nextStep?: () => void;
  prevStep?: () => void;
}

export const SecurityRequired: React.FC<InfoArcConnectProps> = ({
  closeModal,
}) => {
  const { performBiometricAuth } = useBiometricAuth();

  // Modal state for auth failure
  const [isAuthFailedModalOpen, setIsAuthFailedModalOpen] = useState(false);

  const handleProceed = async () => {
    try {
      const success = await performBiometricAuth();
      if (success) {
        closeModal();
      } else {
        setIsAuthFailedModalOpen(true); // show fail modal
      }
    } catch (e) {
      setIsAuthFailedModalOpen(true); // show fail modal
    }
  };

  // Log analytics event when component is mounted
  React.useEffect(() => {
    const logAnalyticsEvent = async () => {
      await analytics.logEvent("onboarding_security_required_viewed", {});
    };
    logAnalyticsEvent();
    // Only run on mount or when selectedTreatments changes
  }, []);

  return (
    <IonContent className="ion-padding onboarding-content">
      <div className="skip-container">
        <button className="skip-link !text-white" onClick={closeModal}>
          Skip Setup
        </button>
      </div>

      <div className="welcome-container">
        <h1 className="main-heading">Enable Biometric Authentication</h1>
        <p
          className="sub-heading text-white"
          style={{
            fontFamily: "Figtree",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "17px",
            lineHeight: "22px",
            textAlign: "center",
            fontFeatureSettings: "'case' on",
            color: "#FFFFFF",
          }}
        >
          Please set up Face ID or passcode to protect your account before
          proceeding.
        </p>
      </div>

      {/* Authentication Failed Modal */}
      <IonModal
        isOpen={isAuthFailedModalOpen}
        onDidDismiss={() => setIsAuthFailedModalOpen(false)}
        className="connect-modal"
        style={{ "--height": "250px" }}
      >
        <div className="p-6 flex flex-col items-center">
          {/* Header with title & close button */}
          <div className="w-full flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold text-center flex-1">
              FaceID Not Set Up
            </h2>
            <button
              onClick={() => setIsAuthFailedModalOpen(false)}
              className="text-gray-400 ml-4"
              aria-label="Close"
            >
              <IonIcon icon={close} style={{ fontSize: "24px" }} />
            </button>
          </div>

          {/* Message */}
          <p className="text-center mb-2">That’s ok!</p>
          <p className="text-center mb-6">
            You can set it up later by going to: <br />
            <strong>Settings &gt; Security &gt; Enable Biometric</strong>
          </p>

          {/* Action Button */}
          <IonButton
            expand="block"
            onClick={closeModal}
            className="primary-button"
          >
            OK
          </IonButton>
        </div>
      </IonModal>

      <div className="button-stack-container" style={{ margin: "20px 0" }}>
        <IonButton className="secondary-button" onClick={handleProceed}>
          Setup
        </IonButton>
        <button className="skip-link" onClick={closeModal}></button>
      </div>
    </IonContent>
  );
};
